export default __webpack_public_path__ + "media/zurb/img/icons/favicon/apple-touch-icon-72x72-fdc71b39c85e36cd08007752d009e0e1.png";